import {
    Directive,
    ElementRef,
    Host,
    HostBinding,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Renderer2
} from "@angular/core";
import { Subject } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";
import { AssetDetailComponent } from "./asset-detail";

/**
 * helper directive for menu items in the asset detail page
 *
 */
@Directive({
    selector: "[brainAssetDetailSectionMenuItem]",
})
export class AssetDetailSectionMenuItemDirective implements OnInit {
    public constructor(
    private assetDetail: AssetDetailComponent,
    private el: ElementRef,
    private renderer: Renderer2
    ) {}

  @Input()
  public brainAssetDetailSectionMenuItem: string;

  public get key(): string {
      return this.brainAssetDetailSectionMenuItem;
  }

  /**
   * css class binding
   */
  @HostBinding("class.active")
  public active = false;

  /**
   * toggle active state for menu item
   */
  public setActive(active: boolean): void {
      this.active = active;
  }

  /**
   * add click listener to element
   */
  @HostListener("click", ["$event"])
  protected activateMenuItem($event: MouseEvent): void {
      $event.stopPropagation();
      $event.preventDefault();

      this.assetDetail.activateSection(this.key);
      this.active = true;
  }

  public ngOnInit(): void {
      this.assetDetail
          .changeSection()
          .pipe(
              map((section) => this.key === section),
              distinctUntilChanged()
          )
          .subscribe((active) => {
              active
                  ? this.renderer.addClass(this.el.nativeElement, "active")
                  : this.renderer.removeClass(this.el.nativeElement, "active");
          });
  }
}

/**
 * directivee which represents a section into the asset detail page
 *
 */
@Directive({
    selector: "[brainAssetDetailSection]",
})
export class AssetDetailSectionDirective implements OnDestroy, OnInit {
  public key: string;

  @HostBinding("class.active")
  public active = false;

  public get bounds(): DOMRect {
      return (this.el.nativeElement as HTMLElement).getBoundingClientRect();
  }

  public get offsetTop(): number {
      return this.el.nativeElement.offsetTop;
  }

  protected destroy$: Subject<boolean> = new Subject();

  public constructor(
    @Host() public assetDetail: AssetDetailComponent,
    private el: ElementRef
  ) {}

  public ngOnInit(): void {
      this.assetDetail.registerSection(this);
  }

  public ngOnDestroy(): void {
      this.assetDetail.unregisterSection(this.key);

      this.destroy$.next(true);
      this.destroy$.complete();
      this.destroy$ = null;
  }
}
